import {Component, ViewContainerRef} from "@angular/core";
import {ChangeTermsPurchaseField} from "./change-terms-purchase-field";
import {AuthService} from "../../services/auth.service";
import {ChangeTermsPurchaseService} from "./change-terms-purchase.service";
import {ToastsManager} from "ng2-toastr";
import {ChangeTermsPurchase} from "./change-terms-purchase";
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute  } from '@angular/router';
import * as moment from 'moment-timezone';

@Component({
    providers: [ChangeTermsPurchaseService],
    selector: 'change-terms-purchase',
    styleUrls: ['./change-terms-purchase.component.css'],
    templateUrl: './change-terms-purchase.component.html'
})

export class ChangeTermsPurchaseComponent {

    private _formFieldsList = {
        purchaseNumber: {
            label: 'Номер процедуры',
            type: 'number'
        },
        startDT: {
            label: 'Дата начала срока подачи заявок',
            type: 'datetime-local'
        },
        endDT: {
            label: 'Дата окончания подачи заявок',
            type: 'datetime-local'
        },
        firstPartsDT: {
            label: 'Дата рассмотрения первых частей',
            type: 'datetime-local'
        },
        finalOfferDate: {
            label: 'Дата окончательных предложений',
            type: 'datetime-local'
        },
        secondPartsDT: {
            label: 'Дата рассмотрения вторых частей',
            type: 'datetime-local'
        },
        secondStageInfo_startDT: {
            label: 'Дата начала подачи заявок (2 этап)',
            type: 'datetime-local'
        },
        secondStageInfo_endDT: {
            label: 'Дата окончания подачи заявок (2 этап)',
            type: 'datetime-local'
        },
        secondStageInfo_firstPartsDT: {
            label: 'Дата рассмотрения первых частей (2 этап)',
            type: 'datetime-local'
        },
        secondStageInfo_finalOfferDate: {
            label: 'Дата окончательных предложений (2 этап)',
            type: 'datetime-local'
        },
        secondStageInfo_secondPartsDT: {
            label: 'Дата рассмотрения вторых частей (2 этап)',
            type: 'datetime-local'
        },
    };

    public userCan : boolean;
    public fields = [];
    
    public isInitData: boolean = false;

    // public fields = [
    //     new ChangeTermsPurchaseField('Номер процедуры', 'purchaseNumber', 'number'),
    //     new ChangeTermsPurchaseField('Дата окончания подачи заявок', 'endDT', 'datetime-local'),
    //     new ChangeTermsPurchaseField('Дата рассмотрения первых частей', 'firstPartsDT', 'datetime-local'),
    //     new ChangeTermsPurchaseField('Дата окончательных предложений', 'finalOfferDate', 'date'),
    //     new ChangeTermsPurchaseField('Дата рассмотрения вторых частей', 'secondPartsDT', 'datetime-local')
    // ];



    public constructor(
        public auth: AuthService,
        private service: ChangeTermsPurchaseService,
        private toastr: ToastsManager,
        private view_container: ViewContainerRef,
        private http: HttpClient,
        private router: Router,
        private route: ActivatedRoute
    ) {
        toastr.setRootViewContainerRef(this.view_container);
    }

    ngOnInit() {
        this._getProcedure();
    }

    public update() {
        let data = new ChangeTermsPurchase;
        for(let field of this.fields) {
            data[field.name] = field.value;
        }
        this.service.update(data).subscribe(data => {
            if(data['status'])
                this.toastr.error(data['error'], 'Ошибка');
            else
                this.toastr.success('Данные успешно обновлены', 'Обновлено');
        });
    }

    /**
     * Получает данные о закупке по ее номеру и заполняет форму
     *
     * @private
     */
    private _getProcedure()
    {
        let data = {
            purchaseNumber: this.route.snapshot.params['number']
        };

        this.service.getProcedure(data).subscribe(data => {
            this.isInitData = true;
            if(data['status'])
            {
                this.toastr.error(data['error'], 'Ошибка');
            }
            else
            {
                this._fillForm(data['data']);
                this.userCan = data['user_can'];
                this.toastr.success('', 'Данные получены');
            }
        });
    }

    /**
     * Заполняет поля формы по шаблону _formFieldsList
     *
     * @param data
     * @private
     */
    private _fillForm(data)
    {
        for (let key in this._formFieldsList) {

            // Задаем значения для параметров input'a
            let lable = this._formFieldsList[key]['label'];
            let name = key;
            let type = this._formFieldsList[key]['type'];
            let value;

            // Преобразуем значение даты для сохранения
            switch (this._formFieldsList[key]['type'])
            {
                case 'datetime-local':
                     value = data[key] ? data[key] : '';
                    //value = data[key] ? moment(data[key],  'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss') : '';
                    break;
                case 'date':
                    value = data[key] ? moment(data[key],  'YYYY-MM-DD').format('DD.MM.YYYY') : '';
                    break;
                default:
                    value = !!data[key]
                        ? data[key]
                        : '';
                    break;
            }

            this.fields.push(
                new ChangeTermsPurchaseField(lable, name, type, value)
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/change-terms-purchase/change-terms-purchase.component.ts